import { AddressSearchSelectField } from './AddressSearchSelectField'
import { withAddressSearchSelectField } from './withAddressSearchSelectField'

const ConnectedAddressSearchSelectField = withAddressSearchSelectField(
  AddressSearchSelectField
)

export { ConnectedAddressSearchSelectField as AddressSearchSelectField }
